import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X, ArrowRight } from "lucide-react";

const STORAGE_KEY = "rl_trial_banner_dismissed_v1";

export default function StickyTrialBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (!dismissed) setVisible(true);
    } catch (err) {
      console.warn("StickyTrialBanner: localStorage read failed.", err?.name);
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch (err) {
      console.warn("StickyTrialBanner: localStorage write failed.", err?.name);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="trial-banner"
      className="bg-zinc-900 text-white text-sm relative"
      role="region"
      aria-label="Free trial offer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3 min-w-0">
          <span className="inline-flex items-center justify-center w-6 h-6 bg-[#DC1C22] shrink-0">
            <Sparkles className="w-3.5 h-3.5" strokeWidth={2.25} />
          </span>
          <span className="truncate">
            <span className="font-mono text-[#7CFFA8] uppercase tracking-wider text-[10px] mr-2">LIMITED</span>
            Get your first resume audit free — no signup, no card. Powered by GPT-5.2.
          </span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/evaluate"
            data-testid="trial-banner-cta"
            className="inline-flex items-center gap-1 px-3 py-1.5 bg-white text-zinc-900 hover:bg-[#DC1C22] hover:text-white text-xs font-medium transition-colors"
          >
            Claim it <ArrowRight className="w-3 h-3" />
          </Link>
          <button
            onClick={dismiss}
            data-testid="trial-banner-dismiss"
            aria-label="Dismiss banner"
            className="p-1.5 text-zinc-400 hover:text-white"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
